module.exports = __webpack_public_path__ + "img/freight_yard5_2.2459e701.png";